var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-select',_vm._g(_vm._b({attrs:{"value":_vm.value,"multiple":false,"id-key":"form_id","label-key":"form_name","options":_vm.forms_val,"placeholder":_vm.placeholder},scopedSlots:_vm._u([{key:"option-label",fn:function(ref){
var node = ref.node;
var shouldShowCount = ref.shouldShowCount;
var count = ref.count;
var labelClassName = ref.labelClassName;
var countClassName = ref.countClassName;
return _c('label',{class:labelClassName},[_c('span',{staticClass:"text-muted"},[_vm._v("["+_vm._s(node.id)+"]")]),_vm._v("\n        "+_vm._s(node.label)+"\n    ")])}},{key:"value-label",fn:function(ref){
var node = ref.node;
return _c('div',{},[_c('span',{staticClass:"text-muted"},[_vm._v("["+_vm._s(node.id)+"]")]),_vm._v("\n        "+_vm._s(node.label)+"\n    ")])}}])},'x-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }